import api from '../api';

export const fetchPendingReviews = (data) => api.post('/core/functions/fetchPendingReviews', data);

export const fetchReviews = (data) => api.post('/core/functions/fetchReviews', data);
